import React from "react";
import { Skeleton } from "antd";

interface TableSkeletonProps {
  rows?: number;
  className?: string;
}

/**
 * Shared table loading placeholder (same pattern as Catalog).
 */
const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 10,
  className = "",
}) => (
  <div
    className={`table-skeleton data-enter ${className}`.trim()}
    aria-busy="true"
  >
    <Skeleton active title={false} paragraph={{ rows, width: "100%" }} />
  </div>
);

export default TableSkeleton;
